/**
 * 	COMMONS
 * 		Header - Help Center
 */
var moduleHeaderHC = {};

var csts = {
        CHAT_LINK_CONTAINER_ID 		   : "#myChatLinkContainer",
        CP_CHAT_LOGIN_PAGE_PARAM	   : "chat_login_page",
        CP_CHAT_LOGIN_PAGE_URL		   : "/app/chat/chat_landing"
};

var $container = $(csts.CHAT_LINK_CONTAINER_ID);
var inserted = false;

moduleHeaderHC.init = function() {
    // LOAD SPECIFC SCRIPT
    $("#dropdown-help").on('mouseenter', '', function() {
        if(!inserted){
          moduleHeaderHC.insertScript();
        }
    });	
}

moduleHeaderHC.insertScript = function() {
    // Param script
    var script = document.createElement('script');
    script.type = "text/javascript";
    script.src = $container.data('rightnowurl');
    script.onload = moduleHeaderHC.initScript;
    // Append to HEAD
    document.getElementsByTagName('head')[0].appendChild(script);
}

moduleHeaderHC.initScript = function() {
    var widgetUrl = $container.data('widgeturl');
    var chatParameter = {
        container_element_id: "myChatLinkContainer",
        info_element_id: "myChatLinkInfo",
        link_element_id: "myChatLink",
        instance_id: "dkt_chat",
        module: "ConditionalChatLink",
        min_sessions_avail: 1,
        type: 7,
        chat_login_page_width: 400
    };

    // If PTA TOKEN is generated :
    //  > User is authenticated and should be redirect to chat landing page.
    if ($container.data('ptatoken'))
        chatParameter.chat_login_page = '/app/chat/chat_landing';

    RightNow.Client.Controller.addComponent(chatParameter, widgetUrl);
    RightNow.Client.Event.evt_beforeDataRequest.subscribe(moduleHeaderHC.addPta);
    inserted = true;
}

// ----- Private methods -----
moduleHeaderHC.addPta = function (type, args, instance){
    var ptaToken = $(csts.CHAT_LINK_CONTAINER_ID).data('ptatoken');
    var data = args[0];
    if(data) data.pta = ptaToken;
}

module.exports = moduleHeaderHC;


// WEBPACK FOOTER //
// ./src/modules-es5/commons/layout/header-help-center.js